module.exports = __webpack_public_path__ + "exo-latin-200italic.fff0b8fbb6361809277d.woff";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-200italic.woff
// module id = ../../../../typeface-exo/files/exo-latin-200italic.woff
// module chunks = styles